import { useEffect, useRef } from 'react'

import { init } from '@sentry/react'

export const useSentry = (): null => {
  const isSentryInitialized = useRef(false)
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN

  useEffect(() => {
    const isSentry = isSentryInitialized && !isSentryInitialized.current

    if (isSentry && sentryDsn) {
      init({
        dsn: sentryDsn,
      })
    }

    isSentryInitialized.current = true
  }, [sentryDsn])

  return null
}
